// extracted by mini-css-extract-plugin
export default {"count":"Courseware_count__ZxzIs"};